module.exports = __webpack_public_path__ + "tt.fbc6495c.svg";